import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';

/**
 * Owner-only: reject (delete) a pending join request. Idempotent on a
 * subsequent attempt — the endpoint just deletes the row.
 */
export function useRejectJoinRequest(groupId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (requestId: string) =>
      api.delete<{ ok: true }>(
        `/api/groups/${groupId}/join-requests/${requestId}`,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: ['groups', 'join-requests', groupId],
      });
    },
  });
}
